import { Branch } from './branch'
import { CartType } from './common'
import { HistoryStatusObject } from './status'

export enum LogisticStatus {
  new = 'new',
  ready_processing = 'ready_processing',
  waiting = 'waiting',
  for_delivery = 'for_delivery',
  in_process = 'in_process',
  given = 'given',
  denied = 'denied',
  accepted = 'accepted',
  no_accepted = 'no_accepted',
  transferred = 'transferred',
  repeat = 'repeat',
}

export interface LogisticProject {
  id: number
  name: string
}
export interface LogisticAuthor {
  full_name: string
  phone: string
}
export interface LogisticConsultant {
  full_name: string
  phone: string
}

export interface Logistic {
  id: number
  branch?: Branch
  address: string
  comment?: string
  client_full_name: string
  get_cart_type_display: string
  get_status_display: string
  pan: string
  cart_type: CartType
  cost: number
  is_paid: boolean
  phone: string
  project: LogisticProject
  created_at: string

  start_delivery: string
  end_delivery: string

  author?: LogisticAuthor
  consultant?: LogisticConsultant
  status: LogisticStatus

  documents?: Array<{
    id: number
    file: string
    application: string
  }>
  coordinates: {
    type: string,
    coordinates: [number, number],
  }

  status_list?: Array<HistoryStatusObject>
}

export interface LogisticAct {
  id: number
  barcode: string
  created_at: string
  filial?: {
    id: number
    name: string
  }
  amount: number
  status: LogisticStatus
}
